const RedChartSvg = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6447_3849)">
        <path d="M2.5 5.83398L7.5 10.834L10.8333 7.50065L17.5 14.1673" stroke="#EF2121" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.5 8.33398V14.1673H11.6667" stroke="#EF2121" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_6447_3849">
        <rect width="20" height="20" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        
    );
  };
  
  export default RedChartSvg
  